import { type FC } from 'react';

import { Icon } from '@vakantiesnl/components/src/atoms/Icon';
import { Typography } from '@vakantiesnl/components/src/atoms/Typography';

import useStyles from './ImagePlaceholder.style';

export type ImagePlaceholderProps = {
	placeholder?: string;
	size?: 'small' | 'default';
};

export const ImagePlaceholder: FC<ImagePlaceholderProps> = ({ placeholder = '', size }) => {
	const { classes, cx } = useStyles();

	return (
		<div className={cx(classes.container, { [classes.small]: size === 'small' })}>
			<Icon type={'accommodation'} size={size === 'small' ? 'large' : 'xLarge'} />
			{placeholder && (
				<Typography variant={size === 'small' ? 'labelSm' : 'labelMd'} as="span">
					{placeholder}
				</Typography>
			)}
		</div>
	);
};
